export var ModalVariant = /*#__PURE__*/function (ModalVariant) {
  ModalVariant["Fullscreen"] = "fullscreen";
  ModalVariant["Large"] = "large";
  ModalVariant["Small"] = "small";
  return ModalVariant;
}({});